import { CalendarEvent } from 'mini-calendar-event-types';
import { dateRangesOverlap } from 'mini-datetime-utils';
import { format } from 'owa-strings';
import { getAriaLabelForTimeAndDuration } from 'mini-common-utils/lib/utils/getAriaLabelForTimeAndDuration';
import { getOwaMiniCommonStrings } from 'owa-strings/owa-mini-common-strings';

export const getRsvpDayViewItemAriaLabel = (
    item: CalendarEvent,
    currentItem: CalendarEvent
): string => {
    const { Start: itemStart, End: itemEnd, ItemId: { Id: itemId } = {}, Subject } = item;
    const {
        Start: currentItemStart,
        End: currentItemEnd,
        ItemId: { Id: currentItemId } = {},
    } = currentItem;
    const commonStrings = getOwaMiniCommonStrings();
    const eventSubject = Subject || commonStrings.noSubjectText;
    const currentItemDateRange = { start: currentItemStart, end: currentItemEnd };
    const inDayItemDateRange = { start: itemStart, end: itemEnd };
    const isConflicting = dateRangesOverlap(currentItemDateRange, inDayItemDateRange, false) === 0;
    const {
        rsvpDayViewEventDetailsAriaLabel,
        rsvpDayViewCurrentEventAriaLabel,
        rsvpDayViewConflictsAriaLabel,
        rsvpDayViewNoConflictsAriaLabel,
    } = commonStrings;
    const conflictStatus =
        itemId === currentItemId
            ? rsvpDayViewCurrentEventAriaLabel
            : isConflicting
            ? rsvpDayViewConflictsAriaLabel
            : rsvpDayViewNoConflictsAriaLabel;

    return format(
        rsvpDayViewEventDetailsAriaLabel,
        eventSubject,
        getAriaLabelForTimeAndDuration(item),
        conflictStatus
    );
};
